<!-- Wizard Dialog -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '95vw', height: '90vh' }"
  [maximizable]="false"
  styleClass="wizard-dialog"
  (onShow)="onWizardShow()"
  (onHide)="closeWizard()">

  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="wizard-header">
      <div class="wizard-title">
        <i class="pi pi-plus-circle wizard-icon"></i>
        <div class="title-content">
          <h2>{{ referenzaToEdit ? 'Modifica Referenza' : 'Nuova Referenza' }}</h2>
          <p class="title-subtitle">{{ referenzaToEdit ? 'Modifica i dati della referenza' : 'Inserisci i dati della nuova referenza' }}</p>
        </div>
      </div>
      <div class="wizard-progress">
        <span class="progress-text">Step {{ currentStep + 1 }} di {{ visibleSteps.length }}</span>
      </div>
    </div>
  </ng-template>

  <!-- Content -->
  <div class="wizard-content">
    <!-- Avviso di caricamento dati fallito: evita che elenchi vuoti vengano
         scambiati per "nessun risultato" durante le ricerche -->
    <div *ngIf="datiWizardNonCaricati.length > 0" class="wizard-load-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span class="wizard-load-error-text">
        Non è stato possibile caricare: <strong>{{ datiWizardNonCaricati.join(', ') }}</strong>.
        Le ricerche su questi elenchi non daranno risultati finché non vengono ricaricati.
      </span>
      <p-button
        label="Riprova"
        icon="pi pi-refresh"
        severity="secondary"
        size="small"
        [loading]="ricaricaDatiWizardInCorso"
        (onClick)="retryCaricamentoDatiWizard()"></p-button>
    </div>

    <!-- Steps Navigation -->
    <div class="wizard-steps">
      <p-steps [model]="visibleSteps" [(activeIndex)]="currentStep" [readonly]="false" styleClass="wizard-steps-component"></p-steps>
    </div>

    <!-- Step Content -->
    <div class="step-content">
      <!-- Step 1: Informazioni Generali -->
      <div *ngIf="currentStep === 0" class="step-container">
        <!-- <p-card styleClass="step-card"> -->
          <div class="form-grid">
            <!-- Prima riga: Cliente, Commessa, Codice Certificato, Project Manager -->
            <div class="form-field four-columns-row">
              <div class="form-field">
                <label for="cliente">Cliente *</label>
                <p-autoComplete
                  id="cliente"
                  [(ngModel)]="selectedCliente"
                  [suggestions]="clientiSuggestions"
                  (completeMethod)="onClienteComplete($event)"
                  (onSelect)="onClienteSelect($event)"
                  (onClear)="onClienteClear()"
                  [forceSelection]="false"
                  [showEmptyMessage]="true"
                  emptyMessage="Nessun cliente trovato"
                  placeholder="Seleziona il cliente"
                  [field]="'ragioneSociale'"
                  [dropdown]="true"
                  [overlayOptions]="{ baseZIndex: 2100001 }"
                  [inputStyle]="{'width': '100%'}"
                >
                  <ng-template pTemplate="footer">
                    <div style="padding: 0.5rem; text-align: right; border-top: 1px solid var(--surface-border);">
                      <button
                        pButton
                        type="button"
                        icon="pi pi-plus"
                        label="Nuovo Cliente"
                        class="p-button-text p-button-sm"
                        (click)="onCreateNewClienteFromDropdown()"
                        *ngIf="canModify()"
                      ></button>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>

              <div class="form-field">
                <label for="codiceCommessa">Commessa *</label>
                <p-autoComplete
                  id="codiceCommessa"
                  [(ngModel)]="codiceCommessaInput"
                  [suggestions]="commesseSuggestions"
                  (completeMethod)="onCommessaComplete($event)"
                  (onSelect)="onCommessaSelect($event)"
                  [forceSelection]="false"
                  [showEmptyMessage]="true"
                  [emptyMessage]="selectedCliente ? 'Nessuna commessa trovata per questo cliente' : 'Seleziona prima un cliente'"
                  [placeholder]="selectedCliente ? 'Cerca commessa' : 'Seleziona prima un cliente'"
                  [field]="'codice'"
                  [dropdown]="true"
                  [overlayOptions]="{ baseZIndex: 2100001 }"
                  [disabled]="!selectedCliente"
                  [inputStyle]="{'width': '100%'}"
                >
                  <ng-template let-commessa pTemplate="item">
                    <div class="commessa-item">
                      <div class="commessa-codice"><strong>{{ commessa.codice }}</strong></div>
                      <div class="commessa-descrizione" *ngIf="commessa.descrizione">
                        {{ commessa.descrizione.length > 30 ? (commessa.descrizione | slice:0:30) + '...' : commessa.descrizione }}
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <div style="padding: 0.5rem; text-align: right; border-top: 1px solid var(--surface-border);">
                      <button
                        pButton
                        type="button"
                        icon="pi pi-plus"
                        label="Nuova Commessa"
                        class="p-button-text p-button-sm"
                        (click)="onCreateNewCommessaFromDropdown()"
                        *ngIf="canModify() && selectedCliente"
                      ></button>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>

              <div class="form-field">
                <label for="projectManager">Project Manager</label>
                <input
                  id="projectManager"
                  type="text"
                  pInputText
                  [(ngModel)]="referenzaData.projectManager"
                  placeholder="Project Manager"
                />
              </div>
            </div>

            <!-- Codici Certificato con chips -->
            <div class="form-field full-width">
              <label for="codiceCertificato">Certificati</label>
              <div class="chips-input-group">
                <div style="display: flex; gap: 0.5rem; align-items: center;">
                  <input
                    id="codiceCertificato"
                    type="text"
                    pInputText
                    [(ngModel)]="codiceCertificatoInput"
                    (keyup.enter)="addCodiceCertificato()"
                    placeholder="Numero certificato"
                    style="flex: 1;"
                  />
                  <button
                    pButton
                    type="button"
                    icon="pi pi-plus"
                    label="Aggiungi"
                    class="p-button-sm"
                    (click)="addCodiceCertificato()"
                  ></button>
                </div>
                <div class="chips-container-inline" *ngIf="referenzaData.codiciCertificati && referenzaData.codiciCertificati.length > 0">
                  <span
                    class="p-chip"
                    *ngFor="let codice of referenzaData.codiciCertificati"
                  >
                    <span class="p-chip-text">{{ codice }}</span>
                    <span class="p-chip-remove-icon pi pi-times" (click)="removeCodiceCertificato(codice)"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="form-field full-width">
              <label for="titoloBreve">Titolo Breve *</label>
              <input
                id="titoloBreve"
                type="text"
                pInputText
                [(ngModel)]="referenzaData.titoloBreve"
                placeholder="Inserisci il titolo breve"
                required
              />
            </div>

            <div class="form-field full-width">
              <label for="titoloEsteso">Titolo Esteso</label>
              <textarea
                id="titoloEsteso"
                pInputText
                [(ngModel)]="referenzaData.titoloEsteso"
                placeholder="Inserisci il titolo esteso"
                rows="3"
              ></textarea>
            </div>
          </div>
       <!--  </p-card> -->
      </div>

      <!-- Step 2: Dettagli Progetto e Dati Economici -->
      <div *ngIf="currentStep === 1" class="step-container">
        <!-- <p-card styleClass="step-card"> -->
          <!-- Dettagli Progetto -->
          <div class="form-section-title">
            <h4>Dettagli Progetto</h4>
          </div>
          <div class="form-grid seven-columns">
            <div class="form-field">
              <label for="tempistiche">Tempistiche</label>
              <input
                id="tempistiche"
                type="text"
                pInputText
                [(ngModel)]="referenzaData.tempistiche"
                placeholder="Es: 6 mesi, 1 anno"
              />
            </div>

            <div class="form-field">
              <label for="dataFine">Data Fine</label>
              <p-calendar
                id="dataFine"
                [(ngModel)]="referenzaData.dataFine"
                dateFormat="dd/mm/yy"
                placeholder="Seleziona la data fine"
                [showIcon]="true"
                [appendTo]="'body'"
                [baseZIndex]="1000000"
                [showButtonBar]="true"
                [showOnFocus]="false"
                [inputStyle]="{'width': '100%'}"
              ></p-calendar>
            </div>

            <div class="form-field size-field">
              <label for="size">Size</label>
              <input
                id="size"
                type="text"
                pInputText
                [(ngModel)]="referenzaData.valoreDimensione"
                placeholder="Es: 10 m2"
              />
            </div>

            <div class="form-field">
              <div class="switch-group">
                <label>RTP</label>
                <p-inputSwitch [(ngModel)]="referenzaData.rtp"></p-inputSwitch>
              </div>
            </div>

            <div class="form-field">
              <div class="switch-group">
                <label>Capogruppo</label>
                <p-inputSwitch [(ngModel)]="referenzaData.capogruppo"></p-inputSwitch>
              </div>
            </div>

            <div class="form-field">
              <div class="switch-group">
                <label>In AQ</label>
                <p-inputSwitch [(ngModel)]="referenzaData.inAq"></p-inputSwitch>
              </div>
            </div>

            <div class="form-field">
              <div class="switch-group">
                <label>BIM</label>
                <p-inputSwitch [(ngModel)]="referenzaData.bim"></p-inputSwitch>
              </div>
            </div>
          </div>

          <!-- Dati Economici -->
          <div class="form-section-title" style="margin-top: 2rem;">
            <h4>Dati Economici</h4>
          </div>
          <div class="form-grid economic-row">
            <div class="form-field narrow">
              <label for="quotaCooprogetti">Quota Cooprogetti (%)</label>
              <p-inputNumber
                id="quotaCooprogetti"
                [(ngModel)]="referenzaData.quotaCooprogetti"
                [min]="0"
                [max]="100"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                placeholder="Es: 50.00"
                [useGrouping]="false"
              ></p-inputNumber>
            </div>

            <div class="form-field narrow">
              <label for="importoLavori">Importo Lavori (€)</label>
              <p-inputNumber
                id="importoLavori"
                [(ngModel)]="referenzaData.importoLavori"
                [min]="0"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [prefix]="'€ '"
                placeholder="Es: 100000.00"
              ></p-inputNumber>
            </div>

            <div class="form-field narrow">
              <label for="importoServizio">Importo Servizio (€)</label>
              <p-inputNumber
                id="importoServizio"
                [(ngModel)]="referenzaData.importoServizio"
                [min]="0"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [prefix]="'€ '"
                placeholder="Es: 50000.00"
              ></p-inputNumber>
            </div>
          </div>

          <!-- Categorie Servizio -->
          <div class="form-section-title" style="margin-top: 2rem;">
            <h4>Servizi</h4>
          </div>
          <div class="form-section">
            <div class="chips-input-group">
              <p-autoComplete
                [(ngModel)]="categoriaServizioInput"
                [suggestions]="categoriaServizioSuggestions"
                (completeMethod)="onCategoriaServizioInput($event)"
                (onSelect)="onCategoriaServizioSelect($event)"
                (keyup.enter)="addCategoriaServizio()"
                [forceSelection]="false"
                [showEmptyMessage]="true"
                emptyMessage="Nessuna categoria trovata o già selezionata"
                placeholder="Aggiungi un servizio"
                [dropdown]="true"
                [overlayOptions]="{ baseZIndex: 999999 }"
                styleClass="categoria-servizio-input"
                [inputStyle]="{'width': '100%'}"
              ></p-autoComplete>
              <div class="chips-container-inline" *ngIf="referenzaData.categorieServizio && referenzaData.categorieServizio.length > 0">
                <span
                  class="p-chip"
                  *ngFor="let cat of referenzaData.categorieServizio"
                >
                  <span class="p-chip-text">{{ cat }}</span>
                  <span class="p-chip-remove-icon pi pi-times" (click)="removeCategoriaServizio(cat)"></span>
                </span>
              </div>
            </div>
          </div>

          <!-- Servizi Affini -->
          <div class="form-section-title" style="margin-top: 2rem;">
            <h4>Servizi Affini</h4>
          </div>
          <div class="form-section servizi-accessori-section">
            <div class="form-field switch-field">
              <label for="serviziAccessoriPresenti">Presenti</label>
              <div class="switch-control">
                <p-inputSwitch
                  inputId="serviziAccessoriPresenti"
                  [(ngModel)]="referenzaData.serviziAccessoriPresenti"
                  (onChange)="onServiziAccessoriToggle($event)"
                ></p-inputSwitch>
              </div>
            </div>
            <div class="form-field url-field">
              <label for="urlServiziAccessori">URL Servizi Affini</label>
              <input
                id="urlServiziAccessori"
                type="url"
                pInputText
                [(ngModel)]="referenzaData.urlServiziAccessori"
                placeholder="https://esempio.it/link"
                [disabled]="referenzaData.serviziAccessoriPresenti !== true"
              />
            </div>
          </div>
       <!--  </p-card> -->
      </div>

      <!-- Step 3: Posizione (opzionale) -->
      <div *ngIf="currentStep === 2" class="step-container">
        <div class="form-section-title">
          <h4>Posizione geografica</h4>
        </div>

        <div class="form-section">
          <div style="display:flex; align-items:center; justify-content: space-between; gap: 1rem; margin-bottom: 0.75rem;">
            <small style="color: var(--text-color-secondary);">
              Cerca per «Indirizzo + Città» oppure solo «Città». Se non viene trovata una posizione precisa, useremo il centro della città.
              Poi puoi trascinare il marker per rifinire.
            </small>
            <button
              pButton
              type="button"
              icon="pi pi-times"
              label="Rimuovi posizione"
              class="p-button-text p-button-sm"
              (click)="clearGeoPosizione()"
              *ngIf="geoSelectedPosition"
            ></button>
          </div>

          <div class="form-grid economic-row">
            <div class="form-field" style="flex: 1;">
              <label for="geo-address-w">Indirizzo</label>
              <input
                id="geo-address-w"
                type="text"
                pInputText
                [(ngModel)]="geoAddressInput"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Es: Via Roma 10"
                (keyup.enter)="searchGeoPosizione()"
              />
            </div>

            <div class="form-field" style="flex: 1;">
              <label for="geo-city-w">Città</label>
              <input
                id="geo-city-w"
                type="text"
                pInputText
                [(ngModel)]="geoCityInput"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Es: Bologna"
                (keyup.enter)="searchGeoPosizione()"
              />
            </div>

            <div class="form-field" style="display:flex; align-items:flex-end;">
              <button
                pButton
                type="button"
                icon="pi pi-search"
                label="Cerca"
                class="p-button-sm"
                [loading]="geoSearching"
                (click)="searchGeoPosizione()"
              ></button>
            </div>
          </div>

          <div style="margin-top: 1rem;">
            <app-leaflet-map
              [heightPx]="geoMapHeightPx"
              [center]="geoMapCenter"
              [zoom]="geoMapZoom"
              [selectable]="true"
              [markerDraggable]="true"
              [selectedPosition]="geoSelectedPosition"
              (selectedPositionChange)="onGeoMapSelectedPositionChange($event)"
            ></app-leaflet-map>
          </div>
        </div>
      </div>

      <!-- Step 4: Tag (nascosto quando si modifica) -->
      <div *ngIf="currentStep === 3 && !referenzaToEdit" class="step-container">
        <!-- <p-card styleClass="step-card"> -->
          <div class="form-section">
            <div class="tag-filters" *ngIf="groupedCategories.length > 0">
              <div class="tag-filters-header">
                <h3 class="tag-filters-title">
                  <i class="pi pi-tags tag-filters-icon" aria-hidden="true"></i>
                  <span>Tags</span>
                </h3>
              </div>
              <div class="tag-filters-row">
                <div
                  class="tag-filter-group"
                  *ngFor="let group of groupedCategories"
                  [attr.data-group-name]="group.groupName"
                >
                  <div class="tag-group-header">
                    <h3 class="tag-group-title">
                      <span *ngIf="group.groupIcon" class="material-symbols-outlined tag-group-icon">
                        {{ group.groupIcon }}
                      </span>
                      {{ group.groupLabel }}
                    </h3>
                  </div>
                  <div class="tag-group-content">
                    <div
                      class="tag-filter-card"
                      *ngFor="let cat of group.categories"
                    >
                      <div class="tag-select-with-chips">
                        <p-multiSelect
                          class="tag-multiselect"
                          [options]="getTagOptionsForCategory(cat.key)"
                          [(ngModel)]="selectedTagsByCategory[cat.key]"
                          (onChange)="onTagsChanged()"
                          optionLabel="label"
                          optionValue="value"
                          display="chip"
                          [filter]="true"
                          [showHeader]="false"
                          [showClear]="true"
                          [appendTo]="'body'"
                          [overlayOptions]="{ baseZIndex: 2200000 }"
                          placeholder="Seleziona"
                        >
                          <ng-template pTemplate="selectedItems" let-selectedItems>
                            <span *ngIf="!selectedItems || selectedItems.length === 0">
                              Seleziona
                            </span>
                            <span *ngIf="selectedItems?.length === 1">
                              {{ selectedItems[0].label }}
                            </span>
                            <span *ngIf="selectedItems?.length > 1">
                              {{ selectedItems.length }} tag selezionati
                            </span>
                          </ng-template>
                          <ng-template pTemplate="footer">
                            <div style="padding: 0.5rem; text-align: right;">
                              <button
                                pButton
                                type="button"
                                icon="pi pi-plus"
                                label="Nuovo Tag"
                                class="p-button-text p-button-sm new-tag-button"
                                (click)="onCreateNewTagFromDropdown(cat.key)"
                                *ngIf="canModify()"
                              ></button>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                        <div
                          class="tag-selected-chips"
                          *ngIf="getSelectedTagLabels(cat.key).length"
                        >
                          <span
                            class="p-chip p-chip-outline"
                            *ngFor="let label of getSelectedTagLabels(cat.key)"
                          >
                            <span class="p-chip-text">{{ label }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
       <!--  </p-card> -->
      </div>

      <!-- Step 5: Ruoli e soggetti (solo in creazione) -->
      <div *ngIf="currentStep === 4 && !referenzaToEdit" class="step-container roles-step-container">
        <div class="roles-step">
          <div class="roles-header">
            <div class="roles-title">
              <span class="material-symbols-outlined">badge</span>
              <div class="roles-title-text">
                <h4>Ruoli e soggetti</h4>
                <p>Seleziona i ruoli e indica chi li ha ricoperti nella referenza.</p>
              </div>
            </div>
            <div class="roles-stats">
              <div class="stat-card primary">
                <span class="stat-label">Ruoli disponibili </span>
                <span class="stat-value" style="font-weight: 800; font-weight: bold;">{{ ruoliDisponibili.length }}</span>
              </div>
              <div class="stat-card secondary">
                <span class="stat-label">Ruoli assegnati </span>
                <span class="stat-value stat-value-filtered" style="font-weight: 800; font-weight: bold;">{{ ruoliAssignments.length }}</span>
              </div>
            </div>
          </div>

          <div class="roles-layout">
            <!-- Colonna sinistra: selezione ruoli -->
            <section class="roles-left">
              <div class="roles-left-header">
                <h5>Seleziona i ruoli</h5>
                <div class="roles-search">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="ruoliSearchText"
                      (ngModelChange)="filterRuoliList()"
                      placeholder="Cerca per descrizione o codice..."
                    />
                  </span>
                </div>
              </div>

              <div class="roles-actions">
                <button
                  pButton
                  type="button"
                  label="Seleziona tutti"
                  class="p-button-text p-button-sm"
                  (click)="selectAllRuoli()"
                  [disabled]="!ruoliDisponibili.length"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Nessuno"
                  class="p-button-text p-button-sm"
                  (click)="clearAllRuoli()"
                  [disabled]="!ruoliAssignments.length"
                ></button>
              </div>

              <div class="roles-list" *ngIf="ruoliFiltrati.length; else noRuoliStep">
                <div
                  class="roles-list-item"
                  *ngFor="let ruolo of ruoliFiltrati"
                  (click)="toggleRuoloSelection(ruolo)"
                  [class.selected]="isRuoloSelected(ruolo)"
                >
                  <div class="roles-list-item-main">
                    <span class="material-symbols-outlined roles-list-icon">badge</span>
                    <div class="roles-list-text">
                      <span class="roles-list-label">{{ ruolo.descrizione | uppercase }}</span>
                    </div>
                  </div>
                  <div class="roles-list-check">
                    <i
                      class="pi"
                      [ngClass]="isRuoloSelected(ruolo) ? 'pi-check-circle selected' : 'pi-circle-off'"
                    ></i>
                  </div>
                </div>
              </div>
              <ng-template #noRuoliStep>
                <p class="roles-empty">Nessun ruolo disponibile.</p>
              </ng-template>
            </section>

            <!-- Colonna destra: assegnazione persone -->
            <section class="roles-right">
              <h5>Ruoli assegnati</h5>
              <p-table
                [value]="ruoliAssignments"
                [paginator]="false"
                [responsiveLayout]="'scroll'"
                class="roles-table"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 45%;">Ruolo</th>
                    <th style="width: 40%;">Persona</th>
                    <th style="width: 10%; text-align: center;">Firmatario</th>
                    <th style="width: 5%; text-align: center;">Azioni</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-assignment>
                  <tr>
                    <td>
                      <span class="codice-ruolo">{{ assignment.ruolo.descrizione | uppercase }}</span>
                    </td>
                    <td class="persona-cell">
                      <div class="persona-input-wrap">
                        <p-autoComplete
                          [(ngModel)]="assignment.persona"
                          [suggestions]="assignment.profiliSuggestions || []"
                          (completeMethod)="onProfiloComplete($event, assignment)"
                          [forceSelection]="false"
                          [showEmptyMessage]="true"
                          emptyMessage="Nessun profilo trovato"
                          placeholder="Seleziona la persona"
                          [dropdown]="true"
                          [overlayOptions]="{ baseZIndex: 2300000 }"
                          [field]="'displayName'"
                        >
                        </p-autoComplete>
                        <button
                          pButton
                          type="button"
                          icon="pi pi-user-plus"
                          class="p-button-text p-button-sm"
                          pTooltip="Nuovo profilo"
                          tooltipPosition="top"
                          [disabled]="savingNewProfilo"
                          (click)="openCreateProfiloDialog(assignment)"
                        ></button>
                      </div>
                    </td>
                    <td>
                      <div class="firmatario-toggle">
                        <p-inputSwitch
                          [(ngModel)]="assignment.firmatario"
                          [ngModelOptions]="{ standalone: true }"
                        ></p-inputSwitch>
                       <!--  <span class="firmatario-label">
                          {{ assignment.firmatario ? 'Firmatario' : 'Non firmatario' }}
                        </span> -->
                      </div>
                    </td>
                    <td class="actions-cell">
                      <div class="action-buttons">
                        <button
                          pButton
                          type="button"
                          icon="pi pi-copy"
                          class="p-button-rounded p-button-text p-button-info action-btn duplicate-btn"
                          pTooltip="Duplica ruolo"
                          tooltipPosition="top"
                          (click)="duplicateRuoloAssignment(assignment)"
                        ></button>
                        <button
                          pButton
                          type="button"
                          icon="pi pi-trash"
                          class="p-button-rounded p-button-text p-button-danger action-btn delete-btn"
                          pTooltip="Rimuovi ruolo"
                          tooltipPosition="top"
                          (click)="removeRuoloAssignment(assignment)"
                        ></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4" class="empty-message">
                      Nessun ruolo assegnato
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </section>
          </div>
        </div>
      </div>

      <!-- Step 6: Riepilogo -->
      <div *ngIf="(currentStep === 5 && !referenzaToEdit) || (currentStep === 3 && referenzaToEdit)" class="step-container">
        <!-- <p-card styleClass="step-card"> -->
          <div class="summary-content">
            <div class="summary-section">
              <h4>Informazioni Generali</h4>
              <div class="summary-grid">
                <!-- Prima riga: Cliente, Commessa, Certificato, Project Manager -->
                <div class="summary-item">
                  <label>Cliente:</label>
                  <span>{{ referenzaData.cliente || 'N/D' }}</span>
                </div>
                <div class="summary-item summary-item-small">
                  <label>Codice Commessa:</label>
                  <span>{{ referenzaData.codiceCommerciale !== null && referenzaData.codiceCommerciale !== undefined ? referenzaData.codiceCommerciale : 'N/D' }}</span>
                </div>
                <div class="summary-item">
                  <label>Project Manager:</label>
                  <span>{{ referenzaData.projectManager || 'N/D' }}</span>
                </div>
                <!-- Codici Certificato - riga dedicata -->
                <div class="summary-item full-width">
                  <label>Codici Certificato:</label>
                  <div class="chips-container" *ngIf="referenzaData.codiciCertificati && referenzaData.codiciCertificati.length > 0">
                    <span class="p-chip" *ngFor="let codice of referenzaData.codiciCertificati">
                      <span class="p-chip-text">{{ codice }}</span>
                    </span>
                  </div>
                  <span *ngIf="!referenzaData.codiciCertificati || referenzaData.codiciCertificati.length === 0">N/D</span>
                </div>
                <!-- Seconda riga: Titolo Breve e Titolo Esteso sulla stessa riga -->
                <div class="summary-item summary-item-titolo-breve">
                  <label>Titolo Breve:</label>
                  <span>{{ referenzaData.titoloBreve || 'N/D' }}</span>
                </div>
                <div class="summary-item summary-item-titolo-esteso">
                  <label>Titolo Esteso:</label>
                  <span>{{ referenzaData.titoloEsteso || 'N/D' }}</span>
                </div>
              </div>
            </div>

            <div class="summary-section">
              <h4>Dettagli Progetto</h4>
              <div class="summary-grid">
                <div class="summary-item">
                  <label>Tempistiche:</label>
                  <span>{{ referenzaData.tempistiche || 'N/D' }}</span>
                </div>
                <div class="summary-item">
                  <label>Data Fine:</label>
                  <span>{{ formatDate(referenzaData.dataFine) }}</span>
                </div>
                <div class="summary-item">
                  <label>Size:</label>
                  <span>{{ referenzaData.valoreDimensione || 'N/D' }}</span>
                </div>
                <div class="summary-item">
                  <label>RTP:</label>
                  <span>{{ referenzaData.rtp ? 'Sì' : 'No' }}</span>
                </div>
                <div class="summary-item">
                  <label>Capogr.:</label>
                  <span>{{ referenzaData.capogruppo ? 'Sì' : 'No' }}</span>
                </div>
                <div class="summary-item">
                  <label>In AQ:</label>
                  <span>{{ referenzaData.inAq ? 'Sì' : 'No' }}</span>
                </div>
                <div class="summary-item">
                  <label>BIM:</label>
                  <span>{{ referenzaData.bim ? 'Sì' : 'No' }}</span>
                </div>
              </div>
            </div>

            <div class="summary-section">
              <h4>Posizione</h4>
              <div class="summary-grid">
               <!--  <div class="summary-item full-width">
                  <label>Posizione:</label>
                  <span>{{ geoSelectedPosition ? 'Impostata' : 'Non impostata' }}</span>
                </div> -->

                <div class="summary-item full-width" *ngIf="geoSelectedPosition">
                  <div style="margin-top: 0.5rem;">
                    <app-leaflet-map
                      [heightPx]="220"
                      [center]="geoSelectedPosition"
                      [zoom]="14"
                      [selectable]="false"
                      [markerDraggable]="false"
                      [selectedPosition]="geoSelectedPosition"
                    ></app-leaflet-map>
                  </div>
                </div>
              </div>
            </div>

            <div class="summary-section">
              <h4>Dati Economici</h4>
              <div class="summary-grid">
                <div class="summary-item">
                  <label>Quota Cooprogetti:</label>
                  <span>{{ formatQuotaCooprogetti(referenzaData.quotaCooprogetti) }}</span>
                </div>
                <div class="summary-item">
                  <label>Importo Lavori:</label>
                  <span>{{ formatCurrency(referenzaData.importoLavori) }}</span>
                </div>
                <div class="summary-item">
                  <label>Importo Servizio:</label>
                  <span>{{ formatCurrency(referenzaData.importoServizio) }}</span>
                </div>
              </div>
            </div>

            <div class="summary-section">
              <h4>Categorie Servizio</h4>
              <div class="chips-container" *ngIf="referenzaData.categorieServizio && referenzaData.categorieServizio.length > 0">
                <span class="p-chip" *ngFor="let cat of referenzaData.categorieServizio">
                  <span class="p-chip-text">{{ cat }}</span>
                </span>
              </div>
              <span *ngIf="!referenzaData.categorieServizio || referenzaData.categorieServizio.length === 0">Nessuna categoria selezionata</span>
            </div>

            <div class="summary-section">
              <h4>Servizi Affini</h4>
              <div class="summary-grid">
                <div class="summary-item">
                  <label>Presenti:</label>
                  <span>{{ referenzaData.serviziAccessoriPresenti ? 'Sì' : 'No' }}</span>
                </div>
                <div class="summary-item full-width" *ngIf="referenzaData.serviziAccessoriPresenti">
                  <label>URL:</label>
                  <span>{{ referenzaData.urlServiziAccessori || 'N/D' }}</span>
                </div>
              </div>
            </div>

            <div class="summary-section">
              <h4>Tag</h4>
              <div class="tag-summary" *ngIf="referenzaData.tag && referenzaData.tag.length > 0">
                <span class="p-chip p-chip-outline" *ngFor="let tag of referenzaData.tag">
                  <span class="p-chip-text">{{ tag }}</span>
                </span>
              </div>
              <span *ngIf="!referenzaData.tag || referenzaData.tag.length === 0">Nessun tag selezionato</span>
            </div>
          </div>
        <!-- </p-card> -->
      </div>
    </div>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="wizard-footer">
      <div class="footer-left">
        <button
          pButton
          type="button"
          label="Indietro"
          icon="pi pi-arrow-left"
          class="p-button-outlined"
          (click)="prevStep()"
          [disabled]="currentStep === 0"
        ></button>
      </div>

      <div class="footer-right">
        <button
          pButton
          *ngIf="currentStep < visibleSteps.length - 1"
          type="button"
          label="Avanti"
          icon="pi pi-arrow-right"
          iconPos="right"
          [disabled]="!canProceedToNext()"
          (click)="nextStep()"
        ></button>

        <button
          pButton
          *ngIf="currentStep === visibleSteps.length - 1"
          type="button"
          label="Salva"
          icon="pi pi-check"
          iconPos="right"
          [loading]="saving"
          (click)="saveReferenza()"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast per messaggi -->
<p-toast></p-toast>

<!-- Dialog Creazione Tag (identico alla home) -->
<app-create-tag-dialog
  [(visible)]="showCreateTagDialog"
  [tags]="allTags"
  [preselectedCategory]="createTagInitialCategory"
  (tagCreated)="onTagCreatedInWizard()"
></app-create-tag-dialog>

<!-- Dialog Creazione Cliente -->
<app-create-cliente-dialog
  [(visible)]="showCreateClienteDialog"
  [clienti]="clienti"
  (clienteCreated)="onClienteCreatedInWizard()"
></app-create-cliente-dialog>

<!-- Dialog Creazione Commessa -->
<app-create-commessa-dialog
  [(visible)]="showCreateCommessaDialog"
  [commesse]="commesse"
  [preselectedClienteId]="selectedCliente?.id || null"
  (commessaCreated)="onCommessaCreatedInWizard()"
></app-create-commessa-dialog>

<p-dialog
  [(visible)]="showCreateProfiloDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!savingNewProfilo"
  [dismissableMask]="!savingNewProfilo"
  [style]="{ width: '95vw', maxWidth: '420px' }"
  appendTo="body"
  [baseZIndex]="2400000"
  [autoZIndex]="true"
  header="Nuovo profilo"
  styleClass="create-profilo-dialog"
  (onHide)="closeCreateProfiloDialog()"
>
  <div class="create-profilo-form">
    <div class="create-profilo-field">
      <label for="wizardNewProfiloNome">Nome</label>
      <input
        pInputText
        id="wizardNewProfiloNome"
        type="text"
        [(ngModel)]="newProfiloNome"
        [disabled]="savingNewProfilo"
        maxlength="100"
        autocomplete="off"
      />
    </div>
    <div class="create-profilo-field">
      <label for="wizardNewProfiloCognome">Cognome</label>
      <input
        pInputText
        id="wizardNewProfiloCognome"
        type="text"
        [(ngModel)]="newProfiloCognome"
        [disabled]="savingNewProfilo"
        maxlength="100"
        autocomplete="off"
      />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        class="p-button-text"
        [disabled]="savingNewProfilo"
        (click)="closeCreateProfiloDialog()"
      ></button>
      <button
        pButton
        type="button"
        label="Crea"
        icon="pi pi-check"
        [loading]="savingNewProfilo"
        [disabled]="!isNewProfiloFormValid() || savingNewProfilo"
        (click)="createAndAssignProfilo()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
